import { getDatabaseByCountry } from "@shared/utils/station-database";

export type AuthHeader = {
  "x-client-id": string;
  "x-app-id": string;
};

const {
  VITE_CHARGETRIP_GRAPHQL_ENDPOINT,
  VITE_CHARGETRIP_GRAPHQL_WS_TRANSPORT_ENDPOINT,
  VITE_APP_ID,
  VITE_CLIENT_ID,
} = import.meta.env;

export const getChargeTripEndpoint = (): string => {
  if (VITE_CHARGETRIP_GRAPHQL_ENDPOINT) {
    return VITE_CHARGETRIP_GRAPHQL_ENDPOINT;
  }

  return "";
};

export const getChargeTripWSTransportEndpoint = (): string => {
  if (VITE_CHARGETRIP_GRAPHQL_WS_TRANSPORT_ENDPOINT) {
    return VITE_CHARGETRIP_GRAPHQL_WS_TRANSPORT_ENDPOINT;
  }

  return "";
};

const defaultHeader: AuthHeader = {
  "x-client-id": VITE_CLIENT_ID,
  "x-app-id": VITE_APP_ID,
};

export const getAuthenticationHeader = async (): Promise<AuthHeader> => {
  // default scenario, return 1P credentials when no apiKeyMap is provided in the config
  const stationDatabase = await getDatabaseByCountry();

  if (!stationDatabase) return defaultHeader;

  const { keys } = stationDatabase;
  return {
    "x-client-id": keys["x-client-id"],
    "x-app-id": keys["x-application-id"],
  };
};
